const groupSubgroup = (arrayFlag, setGroup) => {
    let objectsGroups = [];
    for (var p = 0; p < arrayFlag.length; p++) {
        for (var u = 0; u < arrayFlag[p].boxes.length; u++) {
            for (var v = 0; v < arrayFlag[p].boxes[u].fields.length; v++) {
                if (arrayFlag[p].boxes[u].fields[v].group !== null) {
                    for (var b = 0; b < arrayFlag[p].boxes[u].fields[v].group.length; b++) {
                        let objectGroup = {};
                        let arrayFields = [];
                        let objectsSubGroups = [];
                        let nameGroup = `${arrayFlag[p].entityDocId}_${arrayFlag[p].id}_${arrayFlag[p].boxes[u].fields[v].group[b].name}`;


                        //if (nameGroup !== '100_100_Adjuntos' && nameGroup !== '9_9_Domicilios') { //ESTO ES PORQUE LO ARMA AUTOMATICO EL ADDSCREEN
                        if (nameGroup !== '100_100_Req' && nameGroup !== '9_9_Domicilios') { //ESTO ES PORQUE LO ARMA AUTOMATICO EL ADDSCREEN

                            for (var m = 0; m < arrayFlag[p].boxes[u].fields[v].group[b].fields.length; m++) {

                                if (arrayFlag[p].boxes[u].fields[v].group[b].fields[m].subGroup !== null) {
                                    //SUBGROUP
                                    for (var e = 0; e < arrayFlag[p].boxes[u].fields[v].group[b].fields[m].subGroup.length; e++) {
                                        let objectSubGroup = {};
                                        let arrayFieldsSubgroup = [];
                                        let nameSubGroup = `subGroup_${arrayFlag[p].entityDocId}_${arrayFlag[p].id}_${arrayFlag[p].boxes[u].fields[v].group[b].fields[m].subGroup[e].name}`;
                                        for (var k = 0; k < arrayFlag[p].boxes[u].fields[v].group[b].fields[m].subGroup[e].fields.length; k++) {
                                            let itemFlag = JSON.parse(JSON.stringify(arrayFlag[p].boxes[u].fields[v].group[b].fields[m].subGroup[e].fields[k]));
                                            arrayFieldsSubgroup.push(itemFlag);
                                        }
                                        objectSubGroup.fields = arrayFieldsSubgroup;
                                        objectSubGroup.id = arrayFlag[p].id;
                                        objectSubGroup.name = nameSubGroup;
                                        objectsSubGroups.push({
                                            [nameSubGroup]: [objectSubGroup]
                                        });
                                    }
                                } else {
                                    //GROUP
                                    let itemFlag = JSON.parse(JSON.stringify(arrayFlag[p].boxes[u].fields[v].group[b].fields[m]));
                                    arrayFields.push(itemFlag);
                                }
                            }
                        }
                        objectGroup.fields = arrayFields;
                        objectGroup.id = arrayFlag[p].id;
                        objectGroup.name = nameGroup;
                        objectGroup.subGroup = objectsSubGroups
                        objectsGroups.push(objectGroup);
                    }
                }
            }
        }
    }

    const newArray = groupDataByName(objectsGroups);
    newArray.forEach((groupedArray) => {
        let nameGroup = groupedArray.name;
        setGroup(prevState => ({
            ...prevState,
            [nameGroup]: groupedArray.props
        }));
    })
}

const groupDataByName = (data) => {
    const groupedData = data.reduce((acc, obj) => {
        const { name, ...rest } = obj;
        const existingGroup = acc.find((group) => group.name === name);
        if (!existingGroup) {
            acc.push({ name, props: [{ name, ...rest }] });
        } else {
            existingGroup.props.push({ name, ...rest });
        }
        return acc;
    }, []);

    return groupedData;
};

export default groupSubgroup;